import { BrandConfig } from './types'
import { importBrandedExperienceConfig } from './utils'

export async function getBrandConfigFromHostname(
    hostname: string,
): Promise<BrandConfig> {
    const defaultConfig = await importBrandedExperienceConfig('default')
    const brandedConfig = await importBrandedExperienceConfig(hostname)

    // Remove fields that should not be fallen back to default
    delete (defaultConfig as Partial<BrandConfig>).newsPathUrl

    // brandedConfig fields override defaultConfig fields
    return {
        ...defaultConfig,
        ...brandedConfig,
    } as BrandConfig
}

export async function getBrandConfig(): Promise<BrandConfig> {
    const { host } = window.location

    return getBrandConfigFromHostname(host)
}
